import { useTranslations } from '@/hooks';
import { AttachmentsTabView } from '@/components/common';
import { ATTACHMENT_TARGETS } from '@/lib/api/attachmentsApi';
import { EMPTY_LIST } from '@/lib/utils';
import { useGetAllocationAttachmentsQuery } from '../api/allocationsApi';

/**
 * Props:
 *   module         the active module route segment
 *   allocationId   the allocation's database id
 *   transactionId  the allocation's displayed id
 */
export const AllocationAttachmentsTabView = ({ module, allocationId, transactionId }) => {
  const t = useTranslations();
  const { data: attachments = EMPTY_LIST } = useGetAllocationAttachmentsQuery({
    module,
    id: allocationId,
  });

  return (
    <AttachmentsTabView
      attachments={attachments}
      target={ATTACHMENT_TARGETS.allocation}
      module={module}
      entityId={allocationId}
      modalTitle={t('ALLOCATIONS_ADD_ATTACHMENT_MODAL_TITLE', { transactionId })}
      addLabel={t('ACTION_ADD_ATTACHMENTS')}
    />
  );
};
